import { Box } from '@mui/material';
import styled from 'styled-components';

export const ActionButtonsContainer = styled(Box)`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;
